import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";

import { db } from "../firebase";

export async function listCommentReports({ status = "pending" } = {}) {
  // Single-field orderBy avoids a composite index; filter status client-side.
  const snap = await getDocs(
    query(collection(db, "commentReports"), orderBy("createdAt", "desc"))
  );
  const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  if (!status || status === "all") return rows;
  return rows.filter((r) => (r.status || "pending") === status);
}

export async function updateCommentReportStatus(reportId, status) {
  if (!reportId || !status) throw new Error("Missing report status.");
  await updateDoc(doc(db, "commentReports", reportId), {
    status,
    reviewedAt: serverTimestamp(),
  });
}
